export function extractList(fetching) {
  if (
    fetching.error ||
    fetching.isLoading ||
    fetching.data === undefined ||
    fetching.data === null
  ) {
    return [];
  }
  return fetching.data.data || [];
}

export function buildMicroFilmPayload(data) {
  return {
    serviceTypeId: data.serviceTypeId,
    agencyName: data.agencyName,
    agencyTypeId: data.agencyTypeId,
    filmTypeId: data.filmTypeId,
    filmCount: data.filmCount,
    isPublished: true,
    status: 3,
  };
}
